"use strict";
/**
 * To update enum/file run next SQL command in data-drip

 select CONCAT('export enum WbfABCs {',actor_list,'}') as copy_me
 from (SELECT 1, string_agg(CONCAT('"', name, '"', ' = ', '"', id, '"'), ', ') AS actor_list
 FROM associated_benefit_contract
 GROUP BY 1) as list;
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WbfABCs = void 0;
// <GENERATED
var WbfABCs;
(function (WbfABCs) {
    WbfABCs["Supporters"] = "afe04bba-e640-4be7-952e-f16e60502a17";
    WbfABCs["Non-Eligible State"] = "2870f869-585c-4b28-94d8-200925f64e33";
    WbfABCs["IDG - NJ Default basket"] = "2c9559d1-9721-49ab-bdf2-253450f4a3ab";
    WbfABCs["IDG - MA Default basket"] = "1dfaba54-6edc-4cc0-acbd-1e3d2e1aa56d";
    WbfABCs["IDG - CT Default basket"] = "a2b7688e-b9ec-401b-b2aa-b97c996c3cf3";
    WbfABCs["IDG - IL Default basket"] = "7dd26d64-c23c-4c55-8265-a06d466933e4";
    WbfABCs["32BJ Massachusetts Default basket"] = "da599cd4-fe2f-4141-80fd-27bcb02baff1";
    WbfABCs["Demonstration Org. Default basket"] = "3707555d-2bbc-47a6-899e-1cd177a013c3";
    WbfABCs["BeneStream Default"] = "6e8ff539-6301-4837-95cf-755504db8340";
    WbfABCs["KFC NY (BeneStream) "] = "64201e4b-2b07-4710-9e51-5d454c8da1d2";
    WbfABCs["IDG Delivery Illinois(00000405)"] = "758d1109-c6e4-42f6-92d3-3fad63cb0436";
    WbfABCs["IDG Delivery New York(00000401)"] = "1ae3e2bc-3261-429f-ba0f-aba2e37aceeb";
    WbfABCs["IDG Delivery Connecticut(00000404)"] = "dbc73466-e739-45e2-8554-6601bbd09098";
    WbfABCs["BCF - NY Default basket"] = "2949ae5d-b0b7-4a62-b627-a7549cee3e38";
    WbfABCs["SEIU 1199"] = "255b35e8-d56f-4963-8633-d5adcc8561cc";
    WbfABCs["32BJ - (CHIP, SNAP, Unemployment)"] = "5b29cc3e-0003-489c-965a-794f99557ca1";
    WbfABCs["Golden Entertainment"] = "e4215bfb-e3b8-4f21-af1a-2638aa8d66e8";
    WbfABCs["Agmart/Santa Sweets (Procacci) (CHIP)"] = "e4bd7caf-4068-4b8e-8553-750180bde18a";
    WbfABCs["ARC Mercer (CHIP)"] = "f52adfef-30a3-46db-8b7d-2f8c8a2e55d7";
    WbfABCs["BrightSpring Health (CHIP, SNAP, Unemployment, Finance referral)"] = "48bc5f03-51f4-4cea-96f3-f2662648708d";
    WbfABCs["Coach USA (CHIP, Unemployment)"] = "c7517ffb-b8c7-4121-9592-bfac385a71e0";
    WbfABCs["Cook Illinois Bus Company (CHIP, WOTC)"] = "dfc97efa-bb7a-4d59-88fd-e071b648b16c";
    WbfABCs["Twin Diamond - Full Circle (CHIP, WOTC)"] = "35d3146d-e409-4010-a0cc-589852bd9663";
    WbfABCs["Drivers Benefits - Medicaid/CHIP Enrollment Office"] = "9834d1d4-c5de-4364-8fa8-745747100df2";
    WbfABCs["Foundations Health - First Source (CHIP)"] = "60175dc5-2926-484a-93c4-0a77947323d7";
    WbfABCs["Grease Monkey (CHIP)"] = "2ef7d662-b21a-4ab3-9ee3-c25edfc8776f";
    WbfABCs["Genesis HealthCare"] = "6f6e70fb-05a8-4eeb-9a0e-2b6d6bfc4a03";
    WbfABCs["KDC/One Lynchburg (CHIP, Unemployed)"] = "dc5cf7c3-6997-4e06-a09c-33f7af9d2a79";
    WbfABCs["Local 272 Teamsters (CHIP)"] = "ac8e4950-e313-4c86-b6e2-7576accee71c";
    WbfABCs["Lynn Agency"] = "050749f7-57fe-44c2-ae50-b80c9d5857b1";
    WbfABCs["Nobu Restaurants (WOTC)"] = "8b322f7e-bdbe-432f-aa62-954eac73edbc";
    WbfABCs["PRG - Production Resource Group (CHIP, COBRA)"] = "536563c0-1331-4640-a1dd-e7fca2864a9c";
    WbfABCs["RCA Healthcare Management (CHIP, WOTC)"] = "af11dd24-1946-4fcd-91a6-e0c8508c4618";
    WbfABCs["Resers Fine Foods (CHIP)"] = "cbbb6b57-de65-468e-9741-ea5f95bffaf4";
    WbfABCs["Drivers Union"] = "d984c54f-2ff2-4a87-b466-b02a543e2a5a";
    WbfABCs["Teamsters Taxi"] = "74d38bc6-d40f-470f-a97b-eaef89dbe6db";
    WbfABCs["Trial"] = "bfe94adb-a579-45b3-9bf4-35785ffdc429";
    WbfABCs["Drivers Union - Dues Deduction"] = "1fba2739-0aac-4351-b059-277b6fa9edb7";
    WbfABCs["IDG FLORIDA (00000109)"] = "0a097aa2-a955-4232-8b62-30e76e294595";
    WbfABCs["IDG Delivery New Jersey(00000402)"] = "a9363566-1a9b-4741-968d-64a4acf0611e";
    WbfABCs["IDG Delivery Massachusetts(00000403)"] = "6f5c77c9-a3c1-436f-b078-2159b9e84acd";
    WbfABCs["Obran/Tribeworks Artists"] = "bbf8d5a6-e4ff-4b8d-9127-47923ba19d9a";
    WbfABCs["Rural King (CHIP)"] = "50258f67-a69d-44db-9712-51fbe3dd56fd";
    WbfABCs["San Francisco Art Institute (CHIP, Unemployed)"] = "171d955e-6026-436f-b98f-64335534edb8";
    WbfABCs["Signode (CHIP - Call Benefit Advisors to come off plan 888-628-3136)"] = "8c176c8b-56b4-43cf-bcb6-fc6bb3b1f427";
    WbfABCs["AAK Foodservice (CHIP)"] = "952daee4-aae9-49d5-ae4f-bc6c7f15db3d";
    WbfABCs["Gathr Outdoors (CHIP)"] = "0b19f071-12b3-4cb8-b375-bb0ec92368c7";
    WbfABCs["Majestic Care / Bluegrass (CHIP)"] = "3a73763d-048f-42e9-8bda-b4711de8b3cc";
    WbfABCs["LIFES WORC INC (CHIP)"] = "3e5e456a-2de4-413e-98f1-9f4a4693f1c4";
    WbfABCs["CCM: Dirt Cheap OR Treasure Hunt (CHIP, SNAP doc, Unemployment, Finance referral)"] = "def8cff9-5df9-46b0-8b60-6cfaf9f79e31";
    WbfABCs["Resource Environmental Solutions (CHIP, COBRA)"] = "6954bae4-de4e-445d-9a50-ca873702e262";
    WbfABCs["Tailwind Concessions - Airports (CHIP, Part-timers)"] = "37b027cd-c760-4d45-94ab-518278954045";
    WbfABCs["SEIU 1199 Screening Only Program"] = "8bfcc115-ad93-4b87-8f45-7b83da8c3382";
    WbfABCs["IDG NY - Member"] = "2e7e7629-a628-468f-ad83-566c22b89737";
    WbfABCs["IDG NY - Dues Paying Member"] = "f20593d3-ec5f-497c-b1e9-b75e4dbd9984";
    WbfABCs["Drivers Union Medicaid/CHIP Office"] = "53324e4a-4368-4a52-bf2d-2ebcf7d0d498";
    WbfABCs["Drivers Union - Paid Family Leave"] = "4853a62a-898e-4eb8-b723-1e40c37e66b2";
})(WbfABCs || (exports.WbfABCs = WbfABCs = {}));
// >
//# sourceMappingURL=wbf-abcs.js.map